import { TypedDocumentNode } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { Mutation, MutationVerifyAccountArgs } from 'graphql/generated/graphqlTypes';
import { VERIFY_ACCOUNT } from 'graphql/mutations';
import { setCurrentTenantAction } from 'state/actions/currentTenant';
import { ignoreHandledMutationError } from 'utils/Mutation/ignoreHandledMutationError';
import { BaseHookProps } from '../shared/types';

// Typing the documents (instead of passing generics to the Apollo hooks) avoids the deprecated hook signatures.
const VERIFY_ACCOUNT_TYPED: TypedDocumentNode<
  Pick<Mutation, 'verifyAccount'>,
  MutationVerifyAccountArgs
> = VERIFY_ACCOUNT;

const useVerifyCode = ({ handleFetchError }: BaseHookProps) => {
  const [verifyCognitoUserMutation, { loading, error }] = useMutation(VERIFY_ACCOUNT_TYPED, {
    onCompleted: (data) => {
      setCurrentTenantAction(data.verifyAccount);
    },
    onError: () => {
      handleFetchError('Error while verifying user');
    }
  });

  const verifyCognitoUser = async (email: string, code: string) => {
    const result = await ignoreHandledMutationError(
      verifyCognitoUserMutation({
        variables: {
          email,
          code
        }
      })
    );
    return result;
  };

  return {
    loading,
    verifyCognitoUser,
    error
  };
};

export default useVerifyCode;
